import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import {IconPanel,IconPanelBottom,IconPanelRight, IconPanelLeft} from './Icons';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class PanelRadio extends Component{

  @observable trans = {  };

  @observable panelPosition = 'right';
  @observable mobileSize = false;

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    if ( $(window).width() < 1030 ){
      this.mobileSize = true;
      Settings.setPanelPosition('bottom');
    }
    else
    {
      this.mobileSize = false;
    }


    $(window).on('resize',()=>{
      //todo: move to one place ( fast fix )
      if ( $(window).width() < 1030 ){
        this.mobileSize = true;

        Settings.setPanelPosition('bottom');
      }
      else
      {
        this.mobileSize = false;


      }
    })
  }


  @action setPanelPosition = (val) => {

     if ( this.mobileSize && ( val == 'right' || val == 'left') ) {

       Settings.setPanelPosition('bottom');
     }
     else
     {

       Settings.setPanelPosition(val);
     }


  }

  render() {

    const t = this.t;

    return (
      <div className="PanelRadio">
        {
          ( Settings.getSettingsDevice == 'mobile' )
          &&
          <div className="UniversalPrevent"></div>
        }

        <button className={( Settings.getSettingsPanelPosition == 'right' ? 'active ' : '' ) + ( this.mobileSize ? ' PanelRadio-disabled ' : '' )} onClick={  ()=>{ this.setPanelPosition('right')}}>
          <span className={"button-inside"}><IconPanelRight /></span>
          <span>{t('Right')}</span>
        </button>
        <button className={(Settings.getSettingsPanelPosition == 'top' ? 'active' : '' )} onClick={()=>{this.setPanelPosition('top')}}>
          <span className="button-inside"><IconPanel /></span>
          <span>{t('Top')}</span>
        </button>
        <button className={( Settings.getSettingsPanelPosition == 'left' ? 'active' : '' ) + ( this.mobileSize ? ' PanelRadio-disabled ' : '' ) } onClick={ ()=>{this.setPanelPosition('left')}}>
          <span className="button-inside"><IconPanelLeft /></span>
          <span>{t('Left')}</span>
        </button>
        <button className={( Settings.getSettingsPanelPosition == 'bottom' ? 'active' : '' )} onClick={()=>{this.setPanelPosition('bottom')}}>
          <span className="button-inside"><IconPanelBottom  /></span>
          <span>{t('Bottom')}</span>
        </button>
      </div>
    );

  }
}


